import { truncate } from '@/assets/styles/mixins/index.styles'
import { CustomDropdown } from '@atbay/cyber-components'
import { TTheme } from '@core/theme'
import { styled } from '@mui/system'
import { motion } from 'framer-motion'
import { Variants } from 'framer-motion'
import Typography from '../typography'

export const StyledHeader = styled('div')<{ theme?: TTheme }>`
    padding: 24px 0;
    display: flex;
    justify-content: start;
    gap: 24px;
    align-items: center;
    flex-wrap: wrap;
`

export const Filter = styled('div')<{ theme?: TTheme }>`
    position: relative;
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
`

export const FilterLabelsRow = styled('div')<{ theme?: TTheme }>`
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    width: 100%;
`

export const FilterLabelsContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
`

export const ServiceRequestButton = styled('button')<{ theme?: TTheme }>`
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-primary-200);

    svg {
        margin: 0 8px;
    }
`

export const StyledCustomDropdown = styled(CustomDropdown)<{
    theme?: TTheme
    disabled?: boolean
}>`
    &.custom-dropdown {
        button {
            color: ${({ theme }) => theme.colors.primary[900]};
        }
        background-color: ${({ theme, disabled }) =>
            disabled ? theme.colors.greys[50] : theme.colors.greys[50]};
        .dropdown-trigger {
            min-height: auto;
            padding: 5px 16px;
            span {
                font-size: var(--font-size-xs);
            }
            svg {
                width: 12px;
                aspect-ratio: 1;
            }
            &:hover {
                cursor: ${({ disabled }) =>
                    disabled ? 'not-allowed' : 'pointer'};
            }
        }

        .dropdown-content {
            min-width: 195px;
            width: fit-content;
            background-color: ${({ theme }) => theme.colors.greys[50]};
            .option-item {
                span {
                    max-width: 350px;
                    ${truncate}
                }
            }
        }

        .custom-search-bar {
            background-color: ${({ theme }) => theme.colors.greys[50]};
            border: 1px solid
                ${({ theme }) => theme.colors.semantic.inputBorder} !important;

            .MuiInputBase-input {
                color: ${({ theme }) => theme.colors.greys[500]};
            }
        }
    }
`

export const ResetFilterButton = styled(motion(Typography))<{
    theme?: TTheme
}>`
    color: ${({ theme }) => theme.colors.greys[600]};
    font-size: var(--font-size-s);
    &:hover {
        cursor: pointer;
    }
`

// Animation variants
export const containerVariants: Variants = {
    hidden: { opacity: 0, height: 0 },
    visible: {
        opacity: 1,
        height: 'auto',
        transition: {
            duration: 0.25,
            ease: [0.4, 0, 0.2, 1],
            staggerChildren: 0.08,
        },
    },
    exit: {
        opacity: 0,
        height: 0,
        transition: {
            duration: 0.2,
            ease: [0.4, 0, 1, 1],
        },
    },
}

export const filterLabelVariants: Variants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1],
        },
    },
    exit: {
        opacity: 0,
        y: -10,
        transition: {
            duration: 0.2,
            ease: [0.4, 0, 1, 1],
        },
    },
}

export const clearButtonVariants: Variants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.3,
            ease: [0.4, 0, 0.2, 1],
            delay: 0.15,
        },
    },
    exit: {
        opacity: 0,
        y: -10,
        transition: {
            duration: 0.2,
            ease: [0.4, 0, 1, 1],
        },
    },
}
